var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 54,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8444_209)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M45.8921 24.2248C45.8921 22.2862 43.919 21.6936 43.4102 19.9032C40.9283 11.2602 34.8476 6.32129 26.0369 6.32129C17.2261 6.32129 11.1454 11.2602 8.66354 19.9032C8.15475 21.6936 6.18164 22.2862 6.18164 24.2248C6.18164 34.1149 15.0669 42.1282 26.0369 42.1282C37.0069 42.1282 45.8921 34.1149 45.8921 24.2248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4103 20.5462C43.1372 20.5462 42.8891 20.3733 42.8146 20.1017C40.3823 11.6315 34.4258 6.96421 26.0369 6.96421C17.6481 6.96421 11.704 11.6315 9.27169 20.1017C9.17241 20.435 8.83736 20.6202 8.5023 20.5215C8.16724 20.4227 7.9811 20.0893 8.08038 19.7559C10.674 10.7178 17.0525 5.72949 26.0369 5.72949C35.0214 5.72949 41.4123 10.7178 44.0059 19.7559C44.1052 20.0893 43.9066 20.4227 43.584 20.5215C43.5219 20.5338 43.4723 20.5462 43.4103 20.5462Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4589 38.4246L26.0494 40.894L13.6399 38.4246L11.158 40.894C11.158 40.894 11.158 49.5371 26.0494 50.7718C40.9408 49.5371 40.9408 40.894 40.9408 40.894L38.4589 38.4246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1214 32.1443C21.6281 31.5779 21.9185 28.6676 20.7702 25.6439C19.6219 22.6203 17.4697 20.6284 15.9631 21.1948C14.4565 21.7613 14.166 24.6716 15.3143 27.6952C16.4626 30.7188 18.6148 32.7108 20.1214 32.1443Z",
    fill: "url(#paint0_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.81 31.3249C21.0923 30.8429 21.3403 28.3681 20.364 25.7974C19.3877 23.2266 17.5568 21.5335 16.2746 22.0155C14.9923 22.4976 14.7443 24.9724 15.7206 27.5431C16.6969 30.1139 18.5278 31.807 19.81 31.3249Z",
    fill: "url(#paint1_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0685 21.2858C8.01887 21.0759 6.80273 16.2482 6.80273 13.7293C6.80273 11.2105 8.00646 6.37041 8.0685 6.17285L9.27223 6.46918C9.27223 6.46918 8.0561 11.3587 8.0561 13.7293C8.0561 16.1 9.27223 20.9401 9.27223 20.9895L8.0685 21.2858Z",
    fill: "url(#paint2_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29636 6.93889C7.93131 6.93889 6.81445 5.82764 6.81445 4.46944C6.81445 3.11125 7.93131 2 9.29636 2C10.6614 2 11.7783 3.11125 11.7783 4.46944C11.7783 5.82764 10.6614 6.93889 9.29636 6.93889ZM9.29636 3.23472C8.61383 3.23472 8.0554 3.79035 8.0554 4.46944C8.0554 5.14854 8.61383 5.70417 9.29636 5.70417C9.97888 5.70417 10.5373 5.14854 10.5373 4.46944C10.5373 3.79035 9.97888 3.23472 9.29636 3.23472Z",
    fill: "url(#paint3_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8747 27.6886C38.023 24.665 37.7326 21.7546 36.2259 21.1882C34.7193 20.6217 32.5671 22.6137 31.4188 25.6373C30.2705 28.6609 30.561 31.5713 32.0676 32.1377C33.5742 32.7041 35.7264 30.7122 36.8747 27.6886Z",
    fill: "url(#paint4_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4685 27.5352C37.4448 24.9644 37.1968 22.4897 35.9145 22.0076C34.6323 21.5255 32.8014 23.2187 31.8251 25.7894C30.8488 28.3601 31.0968 30.8349 32.3791 31.317C33.6613 31.7991 35.4922 30.1059 36.4685 27.5352Z",
    fill: "url(#paint5_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1178 21.2858L42.9141 20.9895C42.9141 20.9895 44.1302 16.1 44.1302 13.7293C44.1302 11.3587 42.9141 6.51857 42.9141 6.46918L44.1178 6.17285C44.1674 6.38275 45.3836 11.2105 45.3836 13.7293C45.3836 16.2482 44.1798 21.0883 44.1178 21.2858Z",
    fill: "url(#paint6_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9016 6.93864C41.5365 6.93864 40.4197 5.82739 40.4197 4.4692C40.4197 3.11101 41.5365 1.99976 42.9016 1.99976C44.2666 1.99976 45.3835 3.11101 45.3835 4.4692C45.3835 5.82739 44.2666 6.93864 42.9016 6.93864ZM42.9016 3.23448C42.2191 3.23448 41.6606 3.7901 41.6606 4.4692C41.6606 5.1483 42.2191 5.70392 42.9016 5.70392C43.5841 5.70392 44.1425 5.1483 44.1425 4.4692C44.1425 3.7901 43.5841 3.23448 42.9016 3.23448Z",
    fill: "url(#paint7_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0491 36.2635C16.0594 36.2635 9.71813 26.3364 9.65608 26.2376L9.60645 26.1635V19.8047L9.65608 19.7306C12.2 15.9277 18.3427 15.8906 18.6033 15.8906H18.7274L19.9684 17.1253H32.1173L33.3583 15.8906H33.4824C33.743 15.8906 39.8857 15.94 42.4296 19.7306L42.4792 19.8047V26.1635L42.4296 26.2376C42.3676 26.3364 36.0263 36.2512 26.0366 36.2635H26.0491ZM10.2145 25.9906C10.8102 26.8796 16.8412 35.6462 26.0366 35.6462C35.2445 35.6462 41.2631 26.8796 41.8588 25.9906V20.0022C39.6623 16.8414 34.4875 16.545 33.6064 16.5203L32.3655 17.7551H19.7078L18.4668 16.5203C17.5982 16.545 12.411 16.8414 10.2145 20.0022V25.9906Z",
    fill: "#9155E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 39.9676C26.049 39.9676 26.0242 39.9676 26.0118 39.9676C16.9653 39.9552 9.60645 34.0039 9.60645 26.6943H10.2269C10.2269 33.6705 17.3128 39.3379 26.0366 39.3502C34.7481 39.3502 41.8464 33.6705 41.8464 26.6943H42.4668C42.4668 34.0039 35.108 39.9552 26.0615 39.9676H26.049Z",
    fill: "#56C5D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0495 47.7957C18.8644 47.7957 13.0195 43.6471 13.0195 38.5353C13.0195 38.1896 13.2925 37.918 13.64 37.918C13.9875 37.918 14.2605 38.1896 14.2605 38.5353C14.2605 42.9556 19.5469 46.561 26.0495 46.561C32.5521 46.561 37.8386 42.9556 37.8386 38.5353C37.8386 38.1896 38.1116 37.918 38.459 37.918C38.8065 37.918 39.0795 38.1896 39.0795 38.5353C39.0795 43.6471 33.2346 47.7957 26.0495 47.7957Z",
    fill: "#79FBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 51.4986C10.7118 50.2268 10.5381 41.3862 10.5381 41.0034V40.7442L13.2061 38.0895C13.4543 37.8426 13.839 37.8426 14.0872 38.0895C14.3354 38.3364 14.3354 38.7192 14.0872 38.9662L11.8039 41.238C11.9404 42.6086 13.2434 49.1897 26.112 50.2639C38.8814 49.202 40.1844 42.6209 40.3209 41.238L38.0376 38.9662C37.7894 38.7192 37.7894 38.3364 38.0376 38.0895C38.2858 37.8426 38.6705 37.8426 38.9186 38.0895L41.5867 40.7442V41.0034C41.5867 41.3739 41.413 50.2268 26.1244 51.4986H26.0996Z",
    fill: "url(#paint8_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0489 42.7458C14.7563 42.7458 5.57324 34.4361 5.57324 24.2249C5.57324 22.9038 6.31781 22.1012 6.97552 21.3851C7.44708 20.8788 7.89382 20.3849 8.07996 19.7429C10.6736 10.6924 17.052 5.7041 26.0365 5.7041C35.021 5.7041 41.4119 10.6924 44.0055 19.7305C44.1916 20.3849 44.6384 20.8665 45.11 21.3727C45.7677 22.0889 46.5122 22.8914 46.5122 24.2126C46.5122 34.4237 37.3292 42.7334 26.0365 42.7334L26.0489 42.7458ZM26.0489 6.93882C17.6601 6.93882 11.7035 11.6061 9.27128 20.0763C8.99827 21.0147 8.41502 21.6567 7.89382 22.2247C7.29816 22.8791 6.81419 23.3977 6.81419 24.2373C6.81419 33.7693 15.4388 41.5234 26.0489 41.5234C36.6591 41.5234 45.2837 33.7693 45.2837 24.2373C45.2837 23.3977 44.8121 22.8791 44.2041 22.2247C43.6829 21.6567 43.0872 21.0147 42.8266 20.0763C40.3943 11.6061 34.4378 6.93882 26.0489 6.93882Z",
    fill: "url(#paint9_linear_8444_209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2894 27.2014C10.2026 31.3871 9.50763 31.9057 9.50763 31.9057C9.03607 32.449 8.50246 32.9799 7.34837 32.9922C6.43007 32.9922 5.33803 32.5848 4.09708 31.313C3.91094 31.1402 3.73721 30.9303 3.55106 30.7204C2.53348 29.535 2.47144 27.2631 2.47144 25.6333C2.47144 24.0035 2.73204 23.7689 3.36492 22.6453C3.42697 22.5218 3.50143 22.3983 3.57588 22.2625C4.49419 20.5833 6.40525 19.4597 8.2915 19.1634C8.83752 19.0769 9.35872 19.4226 9.49522 19.9659C9.81787 21.3488 10.3639 24.1887 10.3018 27.189L10.2894 27.2014Z",
    fill: "white",
    stroke: "url(#paint10_linear_8444_209)",
    strokeWidth: 0.777778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0994 27.1933L42.0962 27.0364L42.0844 27.0246C42.0449 24.1306 42.5691 21.4029 42.8827 20.0578C42.9719 19.7091 43.304 19.493 43.6478 19.5475L43.6482 19.5475C45.4426 19.8294 47.2347 20.8979 48.083 22.4491L48.0832 22.4495C48.1165 22.5103 48.1459 22.5621 48.1729 22.6095C48.2153 22.6843 48.2517 22.7483 48.2877 22.8199L48.2918 22.8281L48.2963 22.8361C48.3416 22.9165 48.3844 22.9919 48.4249 23.0634C48.6771 23.5083 48.84 23.7957 48.9517 24.1183C49.0761 24.4777 49.1397 24.8956 49.1397 25.6333C49.1397 26.4468 49.1238 27.3961 48.9861 28.2839C48.8473 29.179 48.5923 29.955 48.1559 30.4648C48.1112 30.5152 48.0688 30.5636 48.0281 30.6102C47.8884 30.77 47.7679 30.9078 47.6384 31.0281L47.6313 31.0346L47.6246 31.0414C46.4375 32.258 45.4409 32.6028 44.6537 32.6034C44.1419 32.5976 43.7892 32.4785 43.5164 32.3147C43.2357 32.1461 43.0179 31.9178 42.7861 31.6508L42.7586 31.6191L42.7506 31.6131C42.7439 31.6041 42.7329 31.5881 42.7184 31.5633C42.6723 31.4843 42.5941 31.3207 42.5083 31.0174C42.3362 30.4086 42.1425 29.2689 42.0994 27.1933Z",
    fill: "white",
    stroke: "url(#paint11_linear_8444_209)",
    strokeWidth: 0.777778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6744 20.5215C45.8471 22.1678 44.5648 26.6951 46.054 31.634",
    stroke: "#9155E7",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65857 20.5215C6.48587 22.1678 7.76819 26.6951 6.27905 31.634",
    stroke: "#9155E7",
    strokeWidth: 0.466667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8444_209",
    x1: 15.9631,
    y1: 21.1948,
    x2: 20.085,
    y2: 32.1581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8657DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8444_209",
    x1: 16.2746,
    y1: 22.0155,
    x2: 19.779,
    y2: 31.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8152C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8444_209",
    x1: 8.03748,
    y1: 6.17285,
    x2: 8.03748,
    y2: 21.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8444_209",
    x1: 9.29636,
    y1: 2,
    x2: 9.29636,
    y2: 6.93889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8444_209",
    x1: 31.4188,
    y1: 25.6373,
    x2: 36.8678,
    y2: 27.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8657DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8444_209",
    x1: 31.8251,
    y1: 25.7894,
    x2: 36.4626,
    y2: 27.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8152C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8444_209",
    x1: 44.1488,
    y1: 6.17285,
    x2: 44.1488,
    y2: 21.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8444_209",
    x1: 42.9016,
    y1: 1.99976,
    x2: 42.9016,
    y2: 6.93864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8444_209",
    x1: 26.0624,
    y1: 37.9043,
    x2: 26.0624,
    y2: 51.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8444_209",
    x1: 26.0427,
    y1: 5.7041,
    x2: 26.0427,
    y2: 42.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8444_209",
    x1: 6.38907,
    y1: 19.1501,
    x2: 6.38907,
    y2: 32.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8444_209",
    x1: 45.611,
    y1: 19.1501,
    x2: 45.611,
    y2: 32.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6736C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8050D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8444_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49.5,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.1b00464f382457945dbcf508253476d6.svg";
export { ForwardRef as ReactComponent };